import { localUpload, convertFiles, deleteFile, compressFiles, cloudUpload, splitFiles, multipartLocalUpload, multipartLocalUploadValidate, getPdfFromLocalFile } from "../dataProvider/file";
import { reloadUser, SET_CLOUD_USAGE, SET_USER } from "./user";
import mime from "mime";

export const ADD_FILE = "ADD_FILE";
export const UPDATE_FILE = "UPDATE_FILE";
export const UPDATE_FILE_FROM_ID = "UPDATE_FILE_FROM_ID";
export const UPDATE_COMPRESS = "UPDATE_COMPRESS";
export const REMOVE_FILE = "REMOVE_FILE";
export const PURGE_FILES = "PURGE_FILES";
export const UPLOAD_STATUS_WAITING_UPLOAD = 'WAITING_UPLOAD';
export const UPLOAD_STATUS_PENDING_UPLOAD = 'PENDING_UPLOAD';
export const UPLOAD_STATUS_WAITING_CUSTOMER = 'WAITING_CUSTOMER';
export const UPLOAD_STATUS_WAITING_PROCESS = 'WAITING_PROCESS';
export const UPLOAD_STATUS_PENDING_PROCESS = 'PENDING_PROCESS';
export const UPLOAD_STATUS_DONE = 'DONE';
export const UPLOAD_STATUS_ERROR_MAX_SIZE = 'ERROR_MAX_SIZE';

/**
 *
 * @param {File[]} file
 * @param {string} mode
 * @returns {Promise}
 */
export const addLocalFiles = (files, mode) => async dispatch => {

    const results = [];

    for (let index = 0; index < files.length; index++) {
        const file = files[index];
        const id = Math.floor(Math.random() * 1000000);

        const result = {
            id,
            fileObject: file,
            name: file.name,
            type: file.type || mime.getType(file.name),
            mode,
            uploadStatus: UPLOAD_STATUS_WAITING_UPLOAD
        }

        if (mode === 'compress') {
            result.size = file.size;
            result.bsGain = Math.round(Math.random() * 20 + 60);
        } else if (mode === 'split') {
            const doc = await getPdfFromLocalFile(file);
            result.pages = doc.numPages;
        }

        results.push(result);
    }

    return dispatch({ type: ADD_FILE, files: results });
}

export const uploadLocalFile = (id) => async (dispatch, getState) => {

    const user = getState().user.user;
    const files = getState().file.files;
    const file = files.find(file => file.id === id);

    if (!file) throw new Error(`Can not file file ${id}`);

    if (file.uploadStatus !== UPLOAD_STATUS_WAITING_UPLOAD) return;

    if (file.fileObject.size > getMaxUploadSize(user?.metadata?.customerType).size) {
        file.uploadStatus = UPLOAD_STATUS_ERROR_MAX_SIZE;
        dispatch({ type: UPDATE_FILE_FROM_ID, file });
        return;
    }

    file.uploadStatus = UPLOAD_STATUS_PENDING_UPLOAD;
    dispatch({ type: UPDATE_FILE_FROM_ID, file });

    let result
    if (file.fileObject.size <= 1024 * 1024 * 50) result = await localUpload(file.fileObject);
    else {
        const upload = await multipartLocalUpload(file.fileObject);
        result = await multipartLocalUploadValidate(upload.fileName, upload.uploadId)
    }

    delete file.fileObject;
    file.url = result.url;
    file.uploadStatus = UPLOAD_STATUS_WAITING_CUSTOMER;
    dispatch({ type: UPDATE_FILE_FROM_ID, file });
}

export const setFilesReadyToProcess = () => (dispatch, getState) => {
    getState().file.files.forEach(file => dispatch({ type: UPDATE_FILE_FROM_ID, file: Object.assign({}, file, { uploadStatus: UPLOAD_STATUS_WAITING_PROCESS }) }))
}

export const updateFile = (index, mode) => dispatch => {
    return dispatch({ type: UPDATE_FILE, index, mode });
}

export const removeFile = (id) => dispatch => {
    return dispatch({ type: REMOVE_FILE, id });
}

export const remove = fileUrl => (dispatch, getState) => {
    return deleteFile(getState().user.user.id, fileUrl)
        .then(result => dispatch({ type: SET_USER, user: result.customer }))
}

export const process = () => async (dispatch, getState) => {
    const user = getState().user.user;
    const toConvertFiles = [];
    const toCompressFiles = [];
    const toSplitFiles = [];
    getState().file.files.forEach(file => {
        if (file.uploadStatus !== UPLOAD_STATUS_WAITING_PROCESS) return;
        file.uploadStatus = UPLOAD_STATUS_PENDING_PROCESS;
        dispatch({ type: UPDATE_FILE_FROM_ID, file });
        if (file.mode === 'convert') toConvertFiles.push(file);
        if (file.mode === 'compress') toCompressFiles.push(file);
        if (file.mode === 'split') toSplitFiles.push({ name: file.name, url: file.url, type: file.type });
    })

    if (toConvertFiles.length) await convertFiles(user.id, toConvertFiles);
    if (toCompressFiles.length) await compressFiles(user.id, toCompressFiles);
    if (toSplitFiles.length) await splitFiles(user.id, toSplitFiles);

    getState().file.files.forEach((file) => {
        if (file.uploadStatus !== UPLOAD_STATUS_PENDING_PROCESS) return;
        return dispatch({ type: REMOVE_FILE, id: file.id });
    })
}

export const addCloudFile = (file) => (dispatch, getState) => cloudUpload(file, getState().user.user.id)

export function getCloudFiles() {
    return async function (dispatch) {
        const user = await dispatch(reloadUser());
        const keys = ["conversions", "compressions", "splits", "cloudUploads"];
        const files = [];
        for (const key of keys) {
            const currentFiles = user.metadata[key] || [];
            for (const currentFile of currentFiles) {
                if (currentFile.status === 'deleted') continue;
                const file = {
                    name: currentFile.name || currentFile.url.split('/')[currentFile.url.split('/').length - 1],
                    url: currentFile.url,
                    date: currentFile.date,
                    status: currentFile.status
                }
                if (key === 'compressions') file.compressed = true;
                if (file.url) {
                    const fileResponse = await fetch(file.url, { method: 'HEAD' });
                    file.size = parseInt(fileResponse.headers.get('content-length'))
                }
                files.push(file);
            }
        }

        const cloudUsage = files.reduce((cloudUsage, file) => {
            if (file.size) cloudUsage += parseInt(file.size);
            return cloudUsage
        }, 0)

        dispatch({ type: SET_CLOUD_USAGE, cloudUsage });

        return files;
    }
}

export function getMaxUploadSize(type) {
    if (type === 'normal') return { size: 1024 * 1024 * 100, label: '100Mo' }
    if (type === 'selfEmployed') return { size: 1024 * 1024 * 500, label: '500Mo' }
    return { size: 1024 * 1024 * 1000, label: '1Go' }
}